import * as i0 from '@angular/core';
import * as i1 from './base-calendar.module';
import * as i2 from '../calendar-kit/components/calendar-header/calendar-header.component';
import * as i3 from '../calendar-kit/components/calendar-navigation/calendar-navigation.component';
import * as i4 from '../calendar-kit/components/calendar-navigation/calendar-pageable-navigation.component';
import * as i5 from '../calendar-kit/components/calendar-days-names/calendar-days-names.component';
import * as i6 from '../calendar-kit/components/calendar-year-picker/calendar-year-picker.component';
import * as i7 from '../calendar-kit/components/calendar-month-picker/calendar-month-picker.component';
import * as i8 from '../calendar-kit/components/calendar-day-picker/calendar-day-picker.component';
import * as i9 from '../calendar-kit/components/calendar-day-picker/calendar-day-cell.component';
import * as i10 from '../calendar-kit/components/calendar-month-picker/calendar-month-cell.component';
import * as i11 from '../calendar-kit/components/calendar-year-picker/calendar-year-cell.component';
import * as i12 from '../calendar-kit/components/calendar-picker/calendar-picker-row.component';
import * as i13 from '../calendar-kit/components/calendar-picker/calendar-picker.component';
import * as i14 from '@angular/common';
import * as i15 from '@angular/forms';
import * as i16 from '@angular/router';
import * as i17 from '../card/card.component';
import * as i18 from '../card/reveal-card/reveal-card.component';
import * as i19 from '../card/flip-card/flip-card.component';
import * as i20 from '../card/shared/shared.component';
import * as i21 from './base-calendar.component';
import * as i22 from '../calendar-kit/calendar-kit.module';
import * as i23 from '../shared/shared.module';
import * as i24 from '../card/card.module';
export const NbBaseCalendarModuleNgFactory:i0.NgModuleFactory<i1.NbBaseCalendarModule> = (null as any);
var _decl0_0:i2.NbCalendarHeaderComponent<any> = (<any>(null as any));
var _decl0_1:i3.NbCalendarNavigationComponent<any> = (<any>(null as any));
var _decl0_2:i4.NbCalendarPageableNavigationComponent<any> = (<any>(null as any));
var _decl0_3:i5.NbCalendarDaysNamesComponent<any> = (<any>(null as any));
var _decl0_4:i6.NbCalendarYearPickerComponent<any> = (<any>(null as any));
var _decl0_5:i7.NbCalendarMonthPickerComponent<any,any> = (<any>(null as any));
var _decl0_6:i8.NbCalendarDayPickerComponent<any,any> = (<any>(null as any));
var _decl0_7:i9.NbCalendarDayCellComponent<any> = (<any>(null as any));
var _decl0_8:i10.NbCalendarMonthCellComponent<any> = (<any>(null as any));
var _decl0_9:i11.NbCalendarYearCellComponent<any> = (<any>(null as any));
var _decl0_10:i12.NbCalendarPickerRowComponent<any,any> = (<any>(null as any));
var _decl0_11:i13.NbCalendarPickerComponent<any,any> = (<any>(null as any));
var _decl0_12:i14.NgClass = (<any>(null as any));
var _decl0_13:i14.NgComponentOutlet = (<any>(null as any));
var _decl0_14:i14.NgForOf<any> = (<any>(null as any));
var _decl0_15:i14.NgIf = (<any>(null as any));
var _decl0_16:i14.NgTemplateOutlet = (<any>(null as any));
var _decl0_17:i14.NgStyle = (<any>(null as any));
var _decl0_18:i14.NgSwitch = (<any>(null as any));
var _decl0_19:i14.NgSwitchCase = (<any>(null as any));
var _decl0_20:i14.NgSwitchDefault = (<any>(null as any));
var _decl0_21:i14.NgPlural = (<any>(null as any));
var _decl0_22:i14.NgPluralCase = (<any>(null as any));
var _decl0_23:i15.ɵangular_packages_forms_forms_bh = (<any>(null as any));
var _decl0_24:i15.NgSelectOption = (<any>(null as any));
var _decl0_25:i15.ɵangular_packages_forms_forms_s = (<any>(null as any));
var _decl0_26:i15.DefaultValueAccessor = (<any>(null as any));
var _decl0_27:i15.ɵangular_packages_forms_forms_be = (<any>(null as any));
var _decl0_28:i15.ɵangular_packages_forms_forms_bg = (<any>(null as any));
var _decl0_29:i15.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_30:i15.SelectControlValueAccessor = (<any>(null as any));
var _decl0_31:i15.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_32:i15.RadioControlValueAccessor = (<any>(null as any));
var _decl0_33:i15.NgControlStatus = (<any>(null as any));
var _decl0_34:i15.NgControlStatusGroup = (<any>(null as any));
var _decl0_35:i15.RequiredValidator = (<any>(null as any));
var _decl0_36:i15.MinLengthValidator = (<any>(null as any));
var _decl0_37:i15.MaxLengthValidator = (<any>(null as any));
var _decl0_38:i15.PatternValidator = (<any>(null as any));
var _decl0_39:i15.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_40:i15.EmailValidator = (<any>(null as any));
var _decl0_41:i15.NgModel = (<any>(null as any));
var _decl0_42:i15.NgModelGroup = (<any>(null as any));
var _decl0_43:i15.NgForm = (<any>(null as any));
var _decl0_44:i15.NgFormSelectorWarning = (<any>(null as any));
var _decl0_45:i16.RouterOutlet = (<any>(null as any));
var _decl0_46:i16.RouterLink = (<any>(null as any));
var _decl0_47:i16.RouterLinkWithHref = (<any>(null as any));
var _decl0_48:i16.RouterLinkActive = (<any>(null as any));
var _decl0_49:i16.ɵEmptyOutletComponent = (<any>(null as any));
var _decl0_50:i17.NbCardComponent = (<any>(null as any));
var _decl0_51:i17.NbCardBodyComponent = (<any>(null as any));
var _decl0_52:i17.NbCardFooterComponent = (<any>(null as any));
var _decl0_53:i17.NbCardHeaderComponent = (<any>(null as any));
var _decl0_54:i18.NbRevealCardComponent = (<any>(null as any));
var _decl0_55:i19.NbFlipCardComponent = (<any>(null as any));
var _decl0_56:i20.NbCardFrontComponent = (<any>(null as any));
var _decl0_57:i20.NbCardBackComponent = (<any>(null as any));
var _decl0_58:i21.NbBaseCalendarComponent<any,any> = (<any>(null as any));
var _decl0_59:i14.AsyncPipe = (<any>(null as any));
var _decl0_60:i14.UpperCasePipe = (<any>(null as any));
var _decl0_61:i14.LowerCasePipe = (<any>(null as any));
var _decl0_62:i14.JsonPipe = (<any>(null as any));
var _decl0_63:i14.SlicePipe = (<any>(null as any));
var _decl0_64:i14.DecimalPipe = (<any>(null as any));
var _decl0_65:i14.PercentPipe = (<any>(null as any));
var _decl0_66:i14.TitleCasePipe = (<any>(null as any));
var _decl0_67:i14.CurrencyPipe = (<any>(null as any));
var _decl0_68:i14.DatePipe = (<any>(null as any));
var _decl0_69:i14.I18nPluralPipe = (<any>(null as any));
var _decl0_70:i14.I18nSelectPipe = (<any>(null as any));
var _decl0_71:i14.KeyValuePipe = (<any>(null as any));
var _decl0_72:i22.NbCalendarKitModule = (<any>(null as any));
var _decl0_73:i23.NbSharedModule = (<any>(null as any));
var _decl0_74:i24.NbCardModule = (<any>(null as any));
var _decl0_75:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_76:i0.ElementRef<any> = (<any>(null as any));
function _View_NbBaseCalendarComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_58.medium;
  currVal_0;
  const currVal_1:any = _decl0_58.large;
  currVal_1;
}
function _View_NbBaseCalendarComponent_1_1():void {
  if (_decl0_58.showHeader) {
    var _any:any = (null as any);
    const pd_0:any = ((<any>_decl0_58.navigateToday()) !== false);
  }
}
function _View_NbBaseCalendarComponent_1_3():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_58.visibleDate;
  currVal_0;
  const pd_1:any = ((<any>_decl0_58.nextMonth()) !== false);
  const pd_2:any = ((<any>_decl0_58.prevMonth()) !== false);
  const pd_3:any = ((<any>_decl0_58.setViewMode(_decl0_58.ViewMode.YEAR)) !== false);
}
function _View_NbBaseCalendarComponent_1_2():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_58.ViewMode.DATE;
  currVal_0;
  const currVal_1:any = _decl0_58.visibleDate;
  currVal_1;
  const currVal_2:any = _decl0_58.boundingMonth;
  currVal_2;
  const currVal_3:any = _decl0_58.min;
  currVal_3;
  const currVal_4:any = _decl0_58.max;
  currVal_4;
  const currVal_5:any = _decl0_58.filter;
  currVal_5;
  const currVal_6:any = _decl0_58.dayCellComponent;
  currVal_6;
  const currVal_7:any = _decl0_58.size;
  currVal_7;
  const currVal_8:any = _decl0_58.date;
  currVal_8;
  const currVal_9:any = _decl0_6.medium;
  currVal_9;
  const currVal_10:any = _decl0_6.large;
  currVal_10;
  const pd_11:any = ((<any>_decl0_58.dateChange.emit(_any)) !== false);
}
function _View_NbBaseCalendarComponent_1_4():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_58.visibleDate;
  currVal_0;
  const currVal_1:any = _decl0_58.date;
  currVal_1;
  const currVal_2:any = _decl0_58.min;
  currVal_2;
  const currVal_3:any = _decl0_58.max;
  currVal_3;
  const currVal_4:any = _decl0_58.filter;
  currVal_4;
  const currVal_5:any = _decl0_58.yearCellComponent;
  currVal_5;
  const currVal_6:any = _decl0_58.size;
  currVal_6;
  const currVal_7:any = _decl0_58.visibleDate;
  currVal_7;
  const currVal_8:any = _decl0_4.medium;
  currVal_8;
  const currVal_9:any = _decl0_4.large;
  currVal_9;
  const pd_10:any = ((<any>_decl0_58.nextYears()) !== false);
  const pd_11:any = ((<any>_decl0_58.prevYears()) !== false);
  const pd_12:any = ((<any>_decl0_58.setViewMode(_decl0_58.ViewMode.DATE)) !== false);
  _decl0_58.setVisibleDate(_any);
  const pd_13:any = ((<any>_decl0_58.setViewMode(_decl0_58.ViewMode.MONTH)) !== false);
}
function _View_NbBaseCalendarComponent_1_5():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_58.visibleDate;
  currVal_0;
  const currVal_1:any = _decl0_58.min;
  currVal_1;
  const currVal_2:any = _decl0_58.max;
  currVal_2;
  const currVal_3:any = _decl0_58.filter;
  currVal_3;
  const currVal_4:any = _decl0_58.size;
  currVal_4;
  const currVal_5:any = _decl0_58.visibleDate;
  currVal_5;
  const currVal_6:any = _decl0_58.monthCellComponent;
  currVal_6;
  const currVal_7:any = _decl0_5.medium;
  currVal_7;
  const currVal_8:any = _decl0_5.large;
  currVal_8;
  const pd_9:any = ((<any>_decl0_58.setViewMode(_decl0_58.ViewMode.DATE)) !== false);
  _decl0_58.setVisibleDate(_any);
  const pd_10:any = ((<any>_decl0_58.setViewMode(_decl0_58.ViewMode.DATE)) !== false);
}
function _View_NbBaseCalendarComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_50.xxsmall;
  currVal_0;
  const currVal_1:any = _decl0_50.xsmall;
  currVal_1;
  const currVal_2:any = _decl0_50.small;
  currVal_2;
  const currVal_3:any = _decl0_50.medium;
  currVal_3;
  const currVal_4:any = _decl0_50.large;
  currVal_4;
  const currVal_5:any = _decl0_50.xlarge;
  currVal_5;
  const currVal_6:any = _decl0_50.xxlarge;
  currVal_6;
  const currVal_7:any = _decl0_50.active;
  currVal_7;
  const currVal_8:any = _decl0_50.disabled;
  currVal_8;
  const currVal_9:any = _decl0_50.primary;
  currVal_9;
  const currVal_10:any = _decl0_50.info;
  currVal_10;
  const currVal_11:any = _decl0_50.success;
  currVal_11;
  const currVal_12:any = _decl0_50.warning;
  currVal_12;
  const currVal_13:any = _decl0_50.danger;
  currVal_13;
  const currVal_14:any = _decl0_50.hasAccent;
  currVal_14;
  const currVal_15:any = _decl0_50.primaryAccent;
  currVal_15;
  const currVal_16:any = _decl0_50.infoAccent;
  currVal_16;
  const currVal_17:any = _decl0_50.successAccent;
  currVal_17;
  const currVal_18:any = _decl0_50.warningAccent;
  currVal_18;
  const currVal_19:any = _decl0_50.dangerAccent;
  currVal_19;
  const currVal_20:any = _decl0_50.activeAccent;
  currVal_20;
  const currVal_21:any = _decl0_50.disabledAccent;
  currVal_21;
  const currVal_22:any = _decl0_58.showHeader;
  currVal_22;
  const currVal_23:any = _decl0_58.activeViewMode;
  currVal_23;
  const currVal_24:any = _decl0_58.ViewMode.DATE;
  currVal_24;
  const currVal_25:any = _decl0_58.ViewMode.YEAR;
  currVal_25;
  const currVal_26:any = _decl0_58.ViewMode.MONTH;
  currVal_26;
}
